import styles from './DropdownSeparator.module.scss';

const DropdownSeparator = () => {
  return <hr className={styles['dropdown-separator']} />;
};

export default DropdownSeparator;
